// this page should wrap all the content in 'Kursus portal' with routes for the underlaying pages.
// React import
import * as React from "react";

import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import Wrapper from "src/components/Wrapper";
import CoursePortalHomePage from './Home';
import Activities from './Activityies';
import ActivityPage from './Activityies/Activity';
import AboutPage from './About';
import MyPage from './MyPage';
import CoursesPage from './Courses';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import Box from 'src/components/Box';
import SearchPage from './SeachPage';
import AdminNews from './AdminNews';
import { IPortalLoadingState } from 'src/Entities/PortalLoadingState/PortalLoadingState';
import { PortalLoadingStateSelector } from 'src/Entities/PortalLoadingState/PortalLoadingState.Selector';
import { LoaderSlate } from 'src/components/Loaders';
import PageEditor from '../PageEditor';
import Page from './Page';
import ThemeSectionEditor from './ThemeSectionEditor';
import ReportStatistics from './Reports/Statistics';
import CourseRedirect from '../CourseRedirect';
import Titles from './Titles';
import ReportDistribution from './Reports/Distribution';

interface IProps{
  loadingState: IPortalLoadingState;
}

// Get course portal data from this page
class CoursePortalMain extends React.Component<IProps> {
  public render() {
    if (!this.props.loadingState.ACTIVITYTHEME) {
      return (
        <Switch>
          <Route exact={true} path="/" component={CoursePortalHomePage} />
          <Route path="/Home" component={CoursePortalHomePage} />
          <Route exact={true} path="/search" component={SearchPage} />
          <Route exact={true} path="/Kurser/" component={CoursesPage} />
          <Route exact={true} path="/Kurser/:themeid" component={Activities} />
          <Route path="/Kursus/" component={ActivityPage} />
          <Route path="/About/:aboutId" component={AboutPage} />
          <Route path="/HelpAndSupport" component={undefined} />
          <Route path="/min-side" component={MyPage} />
          <Route path={'/cms/nyheder/:id?'} component={AdminNews} />
          <Route path="/cms/sider/:id?" component={PageEditor} />
          <Route path="/cms/temasektioner/:id?" component={ThemeSectionEditor} />
          <Route path="/sider/:slug" component={Page} />
          <Route path="/titler/:categoryId/:id" component={Titles} />
          <Route path="/titler/:id" component={Titles} />
          <Route path="/kursusside/:id" component={CourseRedirect} />
          <Redirect from="/rapporter" to="/rapporter/statistik" exact={true} />
          <Route path="/rapporter/statistik" component={ReportStatistics} />
          <Route path="/rapporter/fordeling" component={ReportDistribution} />
        </Switch>
      );
    }

    return (
      <Wrapper>
        <Box>
          <LoaderSlate> Kursusportalen henter opdaterede kurser</LoaderSlate>
        </Box>
      </Wrapper>
    );
  }
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    loadingState: PortalLoadingStateSelector.getLoadingState()
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {};
}
export default withRouter( connect(  mapStateToProps,
  mapDispatchToProps) (CoursePortalMain));



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/index.tsx